const JobApplications = {
  ajaxObject: {
    action: 'update_application_status',
    security: phpObj.ajax_nounce,
    lang: phpObj.current_lang
  },
  init(scope, global) {
    this.global = global
    this.cacheDom(scope)
    this.addEvents()
  },
  cacheDom(scope){
    this.body = scope
    this.jobStatus = this.body.querySelectorAll('.job-status__term');

  },
  addEvents(){
    this.jobStatus.forEach(jobStat => {
      jobStat.addEventListener('click', this.handleJobStatusClick.bind(this)) 
    })

  },
  handleJobStatusClick(e) {
    let clicked = e.target.closest('.job-status__term')
    let row = clicked.closest('tr')
    this.ajaxObject.post_id = row.dataset.postId
    this.ajaxObject.term_id = clicked.dataset.termId
    console.log(this.ajaxObject)
    this.global.postAjax(this.ajaxObject).done(jResponse => console.log(jResponse))
  }
}
module.exports = JobApplications


// WEBPACK FOOTER //
// ./library/src/js/components/job-application.js